import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovaonrentinpune() {



  const cardData = {
"keyword": "Innova on rent in Pune",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Innova on rent in Pune for family trips, airport transfers, corporate travel, pilgrimage tours, and long-distance outstation journeys. Whether you are planning a weekend getaway, business trip, wedding travel, or intercity journey, our Innova cab service ensures a smooth, safe, and stress-free experience. With spacious 7-seater comfort, powerful air-conditioning, ample luggage space, and experienced professional drivers familiar with Pune city and highway routes, we provide a dependable premium travel solution. Our vehicles are well-maintained for long-distance comfort and safety, making them ideal for group and family travel. With transparent pricing and no hidden charges, flexible one-way and round-trip options, doorstep pickup from Pune, easy booking process, and 24/7 customer support, Shivai Travels ensures a comfortable and premium Innova travel experience across Maharashtra and beyond.",

"topPlaces": [
  
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba, frequently visited by families and devotees using Innova rental services for comfortable darshan travel."
  },
  {
    "title": "Nashik & Trimbakeshwar",
    "description":
      "Nashik is known for Trimbakeshwar Jyotirlinga, vineyards, and religious tourism, making it a popular Innova travel destination from Pune."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal beach destination near Mumbai known for clean beaches, forts, and resorts, ideal for relaxing group trips in Innova vehicles."
  },

  {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are the most popular hill stations near Pune, known for waterfalls, green valleys, caves, and scenic viewpoints, making them ideal for Innova family and group trips."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a famous hill station known for strawberries, cool climate, and panoramic viewpoints, often chosen for comfortable Innova outstation travel from Pune."
  },
  {
    "title": "Konkan Beaches (Kashid, Murud, Diveagar)",
    "description":
      "Konkan beaches like Kashid, Murud Janjira, and Diveagar are popular weekend destinations from Pune for scenic coastal drives and beach relaxation."
  },
  {
    "title": "Goa Road Trip",
    "description":
      "Goa is one of the most popular long-distance destinations from Pune, and Innova is widely preferred for comfortable family and group road trips."
  },
  {
    "title": "Ajanta & Ellora Caves",
    "description":
      "Ajanta and Ellora Caves near Aurangabad are UNESCO World Heritage Sites often visited using Innova cars for comfortable long-distance heritage tours."
  },
  {
    "title": "Pune City Tour",
    "description":
      "Innova rentals are also used for Pune city sightseeing covering Shaniwar Wada, Dagdusheth Temple, Aga Khan Palace, and other cultural landmarks."
  },
  {
    "title": "Western Ghats Scenic Route",
    "description":
      "The Pune highway routes pass through the Western Ghats offering lush greenery, ghats, tunnels, and scenic landscapes, making Innova travel smooth and enjoyable."
  }
],



services: [
  {
    name: "Innova Rental Pune",
    description: "Innova rental Pune service provides reliable and spacious transportation for airport transfers, family trips, business travel, sightseeing tours, and outstation journeys. Comfortable Innova vehicles with experienced drivers ensure smooth and safe travel for local and long-distance routes. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles offer spacious seating, air conditioning, and luggage space suitable for family and group travel requirements. Flexible booking options allow convenient Innova rental reservations in Pune."
  },
  {
    name: "Pune Innova Cab Service",
    description: "Pune Innova cab service offers dependable transportation solutions for travelers within Pune and nearby destinations. Vehicles provide spacious seating and smooth highway travel suitable for tourism, corporate outings, airport travel, and family vacations. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Innova Taxi Pune Hire",
    description: "Innova taxi Pune hire service provides affordable and comfortable travel options for local and outstation journeys. Travelers can enjoy smooth trips with experienced drivers familiar with city roads, highways, and tourist destinations. Vehicles ensure spacious seating and safe transportation suitable for business trips, family vacations, and airport travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Innova taxi hire reservations."
  },
  {
    name: "Innova on Hire Pune",
    description: "Innova on hire Pune service provides quality transportation for passengers seeking comfortable and economical SUV-style travel. Vehicles offer spacious interiors, luggage capacity, and smooth ride quality suitable for tourism, office travel, and personal journeys. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova hire reservations."
  },
  {
    name: "Cheap Innova Pune Cab",
    description: "Cheap Innova Pune cab service offers economical and comfortable transportation for families, small groups, and tourists traveling within Pune and nearby destinations. Vehicles provide smooth highway travel suitable for one-day tours, airport transfers, and outstation journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient low-cost Innova reservations."
  },
  {
    name: "Outstation Innova Pune Rental",
    description: "Outstation Innova Pune rental service provides comfortable transportation for families, corporate teams, and tourists traveling from Pune to outstation destinations. Vehicles ensure smooth highway travel with spacious seating and luggage capacity suitable for tourism, business travel, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient outstation Innova reservations."
  },
  {
    name: "Innova Family Car Pune",
    description: "Innova family car Pune service offers spacious and economical transportation for travelers planning family tours, sightseeing journeys, and long-distance travel. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for extended travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient family Innova reservations."
  },
  {
    name: "Pune Innova Booking Service",
    description: "Pune Innova booking service provides reliable transportation for local and outstation travel requirements with spacious vehicles and professional drivers. Vehicles ensure smooth city and highway travel suitable for tourism, airport transfers, office travel, and family outings. Professional chauffeurs ensure safe driving and punctual pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Innova booking reservations."
  },
  {
    name: "Innova One Way Pune Cab",
    description: "Innova one way Pune cab service offers comfortable transportation for one-side journeys from Pune to nearby cities and tourist destinations. Vehicles provide spacious seating and luggage space suitable for airport drops, business trips, tourism, and family travel. Professional chauffeurs ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient one-way Innova reservations."
  },
  {
    name: "Innova Round Trip Pune Taxi",
    description: "Innova round trip Pune taxi service offers reliable transportation for sightseeing tours, family vacations, pilgrimage journeys, and business travel with return options. Vehicles provide comfortable seating and luggage space suitable for families, groups, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient round trip Innova reservations."
  },
  {
    name: "Airport Innova Pune Cab",
    description: "Airport Innova Pune cab service provides complete transportation solutions for airport pickup and drop requirements. Vehicles ensure smooth highway travel suitable for tourism, corporate events, airport transfers, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient airport Innova cab reservations."
  },
  {
    name: "Best Innova Rental Pune",
    description: "Best Innova rental Pune service offers comfortable and dependable transportation with experienced chauffeurs for local and outstation travel. Vehicles are suitable for business meetings, family trips, airport transfers, sightseeing tours, and personal travel. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient premium Innova rental reservations."
  },
  {
    name: "Innova with Driver Pune",
    description: "Innova with driver Pune service provides economical transportation for travelers looking for affordable SUV travel experiences with spacious seating and smooth ride quality. Vehicles are suitable for airport travel, office trips, sightseeing tours, and family outings. Professional chauffeurs ensure smooth journeys and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Innova with driver reservations."
  },
  {
    name: "SUV Innova Hire Pune",
    description: "SUV Innova hire Pune service offers reliable and comfortable SUV transportation for local city rides, airport transfers, business travel, and outstation journeys. Vehicles provide spacious seating and smooth travel suitable for families, groups, and solo travelers. Professional drivers ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient SUV Innova hire reservations."
  },
  {
    name: "Premium Innova Taxi Pune",
    description: "Premium Innova taxi Pune service provides spacious and dependable transportation for group outings, family tours, sightseeing trips, and outstation travel from Pune. Vehicles ensure comfortable seating, luggage space, and smooth highway travel suitable for long journeys and weekend trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient premium Innova taxi reservations."
  }
],

tableData: [
  ["Innova Rental Pune", "Pune Innova Cab Service"],
  ["Innova Taxi Pune Hire", "Innova on Hire Pune"],
  ["Cheap Innova Pune Cab", "Outstation Innova Pune Rental"],
  ["Innova Family Car Pune", "Pune Innova Booking Service"],
  ["Innova One Way Pune Cab", "Innova Round Trip Pune Taxi"],
  ["Airport Innova Pune Cab", "Best Innova Rental Pune"],
  ["Innova with Driver Pune", "SUV Innova Hire Pune"],
  ["Premium Innova Taxi Pune", "Innova Rental Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Innova on Rent in Pune",
        WhyChoosedescription: "Shivai Travels provides reliable Innova rental service in Pune with professional drivers, spacious seating, and punctual pickup for smooth and comfortable travel experiences."
      },
      {
        WhyChooseheading: "Affordable Innova Rental Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Innova on rent in Pune with transparent pricing and no hidden charges. Customers receive complete fare details before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Innova Cab Availability",
        WhyChoosedescription: "Our Innova rental service in Pune operates 24 hours a day for airport transfers, family tours, corporate travel, weddings, outstation trips, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Innova Vehicles",
        WhyChoosedescription: "All Innova vehicles provided by Shivai Travels are fully air-conditioned, sanitized, spacious, and regularly maintained to provide comfortable local and long-distance travel experiences."
      },
      {
        WhyChooseheading: "One Way & Round Trip Innova Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Innova booking, round-trip travel, airport transfers, local sightseeing, and customized outstation travel packages."
      },
      {
        WhyChooseheading: "Ideal Vehicle for Family & Corporate Travel",
        WhyChoosedescription: "Innova is ideal for families, tourists, wedding guests, and corporate travelers with spacious seating, luggage space, and comfortable highway travel experience."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for City & Outstation Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune city routes, highways, Konkan roads, hill stations, and interstate destinations, ensuring safe driving and smooth travel for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Innova rental service in Pune?", answer: "Innova rental service in Pune provides comfortable SUV taxi transportation for airport transfers, family trips, corporate travel, local sightseeing, and outstation journeys." },
    { question: "Is Innova on rent in Pune available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Innova rental service in Pune." },
    { question: "How many passengers can travel in an Innova?", answer: "Innova vehicles are suitable for 6 to 7 passengers with comfortable seating and luggage space." },
    { question: "Can I book Innova for outstation travel?", answer: "Yes, customers can book Innova vehicles for local sightseeing, airport transfers, corporate travel, and outstation tours." },
    { question: "Do you provide one-way and round-trip Innova service?", answer: "Yes, Shivai Travels provides both one-way and round-trip Innova booking services." },
    { question: "Are all Innova vehicles air-conditioned?", answer: "Yes, all Innova vehicles are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Innova on rent in Pune online?", answer: "Yes, customers can easily book Innova rental service online or through phone booking." },
    { question: "Do you provide Innova for airport and corporate travel?", answer: "Yes, Shivai Travels provides Innova vehicles for airport transfers, corporate travel, family trips, and group transportation." },
    { question: "Are Innova rental fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Innova rental in Pune?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Akshay Patil",
      feedback:
        "Booked Innova on rent in Pune with Shivai Travels. Spacious vehicle, smooth journey, and excellent driver support for our family trip.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent Innova rental service in Pune. Affordable pricing, clean vehicle, and wonderful travel experience.",
      rating: 5
    }
  ];









  

  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova on Rent in Pune",
  "image": "https://shivaitravels.com/assets/images/innova-pune.jpg",
  "description": "Book Innova on rent in Pune for comfortable family travel, airport transfers, and outstation trips. Shivai Travels offers reliable Innova cab service with experienced drivers, spacious seating, and affordable pricing for long-distance and group travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shivaitravels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹16/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/innova-on-rent-in-pune"
  }
};





  return (
    <div>

<Helmet>
  <title>Innova on Rent in Pune | SUV Cab Service | +91 9689815477</title>

  <meta
    name="description"
    content="Book Innova on rent in Pune for family trips, airport transfers, and outstation travel. Spacious SUV cab service with driver at affordable rates for comfortable long-distance journeys."
  />

  <meta
    name="keywords"
    content="innova rental pune, pune innova cab service, innova taxi pune hire, innova on hire pune, cheap innova pune cab, outstation innova pune rental, innova family car pune, pune innova booking service, innova one way pune cab, innova round trip pune taxi, airport innova pune cab, best innova rental pune, innova with driver pune, suv innova hire pune, premium innova taxi pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/86.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovaonrentinpune;